<template>
  <div class="srscomponent">
    <v-container fluid
                 class="pa-0">
      <v-row no-gutters>

        <v-col cols="6">

          <v-checkbox v-model="ssrselected"
                      color="primary"
                      hide-details
                      class="pa-0">

            <template slot="label">

               <span class="enabled--text mylabel mr-1">
                 Spezial-Straf-Rechtsschutz
               </span>

              <site-tooltip titel="Spezial-Straf-Rechtsschutz">
                Versicherungsschutz besteht, wenn dem Versicherten vorgeworfen wird, eine Vorschrift des Strafrechtes (Vergehen oder Verbrechen) verletzt zu haben, dessen Begehung vorsätzlich oder fahrlässig strafbar ist. Versicherungsschutz besteht, solange eine rechtskräftige Verurteilung wegen Vorsatzes nicht erfolgt.
              </site-tooltip>

            </template>

          </v-checkbox>

        </v-col>

        <v-col cols="6">
          <v-row no-gutters class="flex-nowrap">

            <template v-if="sb !== 'SB0' || activeTarif === 'securoplus'">

              <v-col cols="6"
                      class="zusatz--column">
                <div :class="ssrselected ? 'selected--text' : 'enabled--text'">
                  {{ getSb(statePath) }}&nbsp;€
                </div>
              </v-col>

              <v-col cols="6"
                      class="zusatz--column">
                <div :class="ssrselected ? 'selected--text' : 'enabled--text'">
                  {{ $helpers.toGermanFloatString(getSrsPrice(ssrsb)) }} €
                </div>
              </v-col>

            </template>

            <template v-else>

              <v-radio-group v-model="ssrsb"
                             :disabled="!ssrselected"
                             :class="!ssrselected ? 'grey-icons' : ''"
                             class="pa-0 fill-parent"
                             hide-details>

                <v-row v-for="(sbp, index) in ['SB150','SB300','SB500']"
                          :key="index"
                          no-gutters
                          class="ssrb-rb flex-nowrap">

                  <v-col cols="6"
                          class="zusatz--column">
                    <v-radio :value="sbp"
                             :disabled="!ssrselected"
                             :color="'primary'"
                             class="ml-12 mt-0 mb-0 mr-0 pa-0 relative">
                      <div slot="label"
                           :class="!ssrselected ? 'disabled--text' : ssrsb === sbp ? 'selected--text' : 'enabled--text'">
                        {{ sbp.slice(2) }}&nbsp;€
                      </div>
                    </v-radio>
                  </v-col>

                  <v-col cols="6"
                          class="zusatz--column">
                    <div :class="!ssrselected ? 'disabled--text' : ssrsb === sbp ? 'selected--text' : 'enabled--text'">
                      {{ $helpers.toGermanFloatString(getSrsPrice(sbp)) }} €
                    </div>
                  </v-col>

                </v-row>

              </v-radio-group>

            </template>

          </v-row>
        </v-col>

      </v-row>
    </v-container>

  </div>
</template>
<script>
import KeyTranslator from "@/components/helper/keyTranslatorMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import {mapGetters} from "vuex";

export default {
  mixins: [twowayBinding, ValidationMixin, KeyTranslator],
  computed: {
    ...mapTwoWay([
      "productLine",
      "family",
      "civilServant",
      "contractlength",
      "zahlweise",
      "sb",
      "ssrselected",
      "ssrsb"
    ]),
    ...mapGetters([
      "getSb",
      "activeTarif",
      "getSecuroFaktor"
    ]),
  },
  watch: {
    sb: {
      immediate: true, // correctly (re-)set ssrb when coming from something that does not have / allow ssr
      handler(newvalue) {
        if (newvalue === "SB0" ) {
          this.ssrsb = "SB150";
        } else {
          this.ssrsb = newvalue;
        }
      }
    }
  },
  methods: {
    getSrsPrice: function (customSb) {
      return this.$store.getters.singlePraemie(
        "SSR",
        this.productLine,
        this.family,
        this.beamterBoolToKey(this.civilServant),
        customSb,
        this.contractlength,
        this.zahlweise,
        this.$store.getters.rabatt(this.statePath),
        undefined,
        1,
        this.getSecuroFaktor(this.statePath)
      );
    }
  }
};
</script>

<style>
.srscomponent .disabled--text {
  color: rgba(0, 0, 0, 0.54);
  font-size: 16px;
}

.srscomponent .selected--text {
  color: #0085CF;
  font-size: 16px;
}

.srscomponent .enabled--text {
  font-size: 16px;
}

.srscomponent .mylabel {
  font-size: 16px;
}

.srscomponent .v-checkbox > label {
  min-width: 100% !important;
  width: 100% !important;
}

.srscomponent .ssrb-rb label {
  color: rgba(0, 0, 0, .87) !important;
}

.srscomponent .ssrb-rb + .ssrb-rb {
  margin-top: 16px !important;
}

.srscomponent .grey-icons .v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
}

.srscomponent .ssrb-rb .v-input.v-radio {
  margin-top: -3px;
}

.srscomponent .relative {
  position: relative;
}

.srscomponent .zusatz--column .v-radio label {
  text-align: right;
  position: absolute!important;
  left: auto!important;
  right: 0!important;
  top: 2px!important;
}
  
</style>
